import axios from 'axios';
import AxisConfig from '../entity/axis-config.entity';

export default class AxisConfigService {
  public static getAxisConfigs(): Promise<AxisConfig[]> {
    return axios.get('/api/axis-configs')
      .then(
        ({ data }: any) => data.map(it => new AxisConfig(it))
          .sort((a, b) => a.type.localeCompare(b.type)),
      );
  }

  public static updateAxisConfigs(axisConfig: AxisConfig[]): Promise<void> {
    return axios.put('/api/axis-configs', axisConfig);
  }
}
